var map = {
	"./ai.svg": "ffe3",
	"./android.svg": "c611",
	"./apk.svg": "ee2c",
	"./css.svg": "6eda",
	"./disc.svg": "ddb5",
	"./doc.svg": "62f5",
	"./docx.svg": "2f10",
	"./excel.svg": "2492",
	"./file.svg": "f9f2",
	"./font.svg": "85a6",
	"./iso.svg": "aaa9",
	"./javascript.svg": "6a4f",
	"./jpeg.svg": "b86a",
	"./jpg.svg": "68c3",
	"./js.svg": "2c1b",
	"./mail.svg": "3b34",
	"./mp3.svg": "82a6",
	"./mp4.svg": "2559",
	"./music.svg": "9e37",
	"./pdf.svg": "f9a9",
	"./php.svg": "379e",
	"./play.svg": "613b",
	"./png.svg": "187b",
	"./powerpoint.svg": "931b",
	"./ppt.svg": "5eba",
	"./pptx.svg": "f046",
	"./psd.svg": "9aac",
	"./record.svg": "3c45",
	"./sql.svg": "f797",
	"./svg.svg": "e6dc",
	"./text.svg": "c5bd",
	"./ttf.svg": "0808",
	"./txt.svg": "583c",
	"./vcf.svg": "9b43",
	"./vector.svg": "0a6a",
	"./video.svg": "1892",
	"./word.svg": "dd8c",
	"./xls.svg": "2369",
	"./xlsx.svg": "2fca",
	"./zip.svg": "1212"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5506";